import _styled from '@emotion/styled';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}
/* eslint-disable no-param-reassign */


var index = function index(breakpoints) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      literal = _ref.literal,
      overlap = _ref.overlap;

  var mq = literal ? breakpoints : ['&'].concat(breakpoints);

  function flatten(obj) {
    if (typeof obj !== 'object' || obj == null) {
      return [];
    }

    if (Array.isArray(obj)) {
      return obj.map(flatten);
    }

    var slots = {};
    var objects = {};
    var props = {};
    Object.keys(obj).forEach(function (key) {
      // Check if value is an array, but skip if it looks like a selector.
      // key.indexOf('&') === 0
      var item = obj[key];
      if (!Array.isArray(item) && literal) item = [item];

      if ((literal || Array.isArray(item)) && key.charCodeAt(0) !== 38) {
        var prior = void 0;
        item.forEach(function (v, index) {
          // Optimize by removing duplicated media query entries
          // when they are explicitly known to overlap.
          if (overlap && prior === v) {
            return;
          }

          if (v == null) {
            // Do not create entries for undefined values as this will
            // generate empty media media quries
            return;
          }

          prior = v;

          if (index === 0 && !literal) {
            props[key] = v;
          } else if (slots[mq[index]] === undefined) {
            var _slots$mq$index;

            slots[mq[index]] = (_slots$mq$index = {}, _slots$mq$index[key] = v, _slots$mq$index);
          } else {
            slots[mq[index]][key] = v;
          }
        });
      } else if (typeof item === 'object') {
        objects[key] = flatten(item);
      } else {
        props[key] = item;
      }
    }); // Ensure that all slots and then child objects are pushed to the end

    mq.forEach(function (el) {
      if (slots[el]) {
        props[el] = slots[el];
      }
    });
    Object.assign(props, objects);
    return props;
  }

  return function () {
    for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }

    return values.map(flatten);
  };
};

var defaultTheme = {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
  },
  maxWidths: {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140
  },
  gutters: 15
};

var isInteger = function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

var getBreakpoints = function getBreakpoints(theme) {
  return Object.values(theme.breakpoints).map(function (bp) {
    return "@media (min-width: " + bp + "px)";
  });
};

var getTheme = function getTheme(theme) {
  var themeConfig = theme || {};
  return _objectSpread({}, defaultTheme, {
    // @ts-ignore
    breakpoints: _objectSpread({}, defaultTheme.breakpoints, themeConfig.breakpoints),
    // @ts-ignore
    maxWidths: _objectSpread({}, defaultTheme.maxWidths, themeConfig.maxWidths)
  }, themeConfig);
};

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-right: ", "px;\n  padding-left: ", "px;\n  margin-right: auto;\n  margin-left: auto;\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = /*#__PURE__*/_styled.div( /*#__PURE__*/_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return getTheme(theme).gutters;
}, function (_ref2) {
  var theme = _ref2.theme;
  return getTheme(theme).gutters;
}, function (_ref3) {
  var fluid = _ref3.fluid,
      theme = _ref3.theme;
  return fluid ? {
    maxWidth: '100%'
  } : index(getBreakpoints(getTheme(theme)))({
    maxWidth: ['100%', getTheme(theme).maxWidths.sm, getTheme(theme).maxWidths.md, getTheme(theme).maxWidths.lg, getTheme(theme).maxWidths.xl]
  });
});

Container.displayName = 'Container';

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: ", ";\n  margin-right: ", ";\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var Row = /*#__PURE__*/_styled.div( /*#__PURE__*/_templateObject$1(), function (_ref) {
  var noGutters = _ref.noGutters,
      theme = _ref.theme;
  return noGutters ? 0 : "-" + getTheme(theme).gutters + "px";
}, function (_ref2) {
  var noGutters = _ref2.noGutters,
      theme = _ref2.theme;
  return noGutters ? 0 : "-" + getTheme(theme).gutters + "px";
});

Row.displayName = 'Row';

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  padding-right: ", "px;\n  padding-left: ", "px;\n\n  ", "\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var toOrder = function toOrder(order) {
  if (!order || typeof order === 'number') {
    return order;
  }

  return order === 'first' ? -1 : 13;
};

var toPercent = function toPercent(n) {
  var percentage = n / 12 * 100;
  return isInteger(percentage) ? percentage + "%" : percentage.toFixed(6) + "%";
};

var Col = /*#__PURE__*/_styled.div( /*#__PURE__*/_templateObject$2(), function (_ref) {
  var noGutters = _ref.noGutters,
      theme = _ref.theme;
  return noGutters ? 0 : getTheme(theme).gutters;
}, function (_ref2) {
  var noGutters = _ref2.noGutters,
      theme = _ref2.theme;
  return noGutters ? 0 : getTheme(theme).gutters;
}, function (p) {
  return index(getBreakpoints(getTheme(p.theme)))({
    marginLeft: [p.xsOffset && toPercent(p.xsOffset), p.smOffset && toPercent(p.smOffset), p.mdOffset && toPercent(p.mdOffset), p.lgOffset && toPercent(p.lgOffset), p.xlOffset && toPercent(p.xlOffset)],
    flex: [p.xs ? "1 0 " + toPercent(p.xs) : '1 0 0', p.sm && "1 0 " + toPercent(p.sm), p.md && "1 0 " + toPercent(p.md), p.lg && "1 0 " + toPercent(p.lg), p.xl && "1 0 " + toPercent(p.xl)],
    maxWidth: [p.xs ? toPercent(p.xs) : '100%', p.sm && toPercent(p.sm), p.md && toPercent(p.md), p.lg && toPercent(p.lg), p.xl && toPercent(p.xl)],
    order: [toOrder(p.xsOrder), toOrder(p.smOrder), toOrder(p.mdOrder), toOrder(p.lgOrder), toOrder(p.xlOrder)]
  });
});

Col.displayName = 'Col';
export { Col, Container, Row };